import { ICustomProperties, IEventTelemetry } from "@microsoft/applicationinsights-web";

export class GotPowerBiTokenEvent implements IEventTelemetry {
    name: string = "GotPowerBiTokenEvent";
    tokenExiresIn: number;
    isRefresh: boolean;

    constructor(tokenExiresIn: number, isRefresh: boolean) {
        this.tokenExiresIn = tokenExiresIn;
        this.isRefresh = isRefresh;
    }

    public getCustomProperties = (): ICustomProperties => {
        return {
            tokenExiresIn: this.tokenExiresIn,
            isRefresh: this.isRefresh,
        };
    };
}
